<!--
  Created 23.06.2023
  Simple Tooltip component
  ...created quickly with the help of ChatGPT 4.0...
-->
<template>
  <div :class="classes">
    <!-- Trigger -->
    <div
      :class="[triggerClass, {'cursor-pointer':!disabled}]"
      @mouseover="show = true"
      @mouseleave="show = false">
      <slot name="trigger" />
    </div>
    <!-- Content -->
    <div
      v-show="show"
      ref="tooltip"
      class="absolute z-20"
      :class="[contentClass,
               {'translate-x-0':align==='left'},
               {'-translate-x-1/2':align==='center'},
               {'translate-x-[calc(-100%+2rem)]':align==='right'},
               {'hidden':disabled}]">
      <slot name="content" />
    </div>
  </div>
</template>

<script setup>
import {
  ref, onMounted, onBeforeUnmount,
} from 'vue';

const props = defineProps({
  align: {
    type: String,
    default: 'center',
    required: false,
    validator: (value) => ['left', 'center', 'right'].includes(value),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  classes: {
    type: [Array, String],
    default: 'relative z-10',
  },
  triggerClass: {
    type: [Array, String],
    default: 'relative',
  },
  contentClass: {
    type: [Array, String],
    default: 'mt-2 bg-gray-900 text-gray-100 w-max p-2 rounded opacity-95',
  },
});

const show = ref(false);
const tooltip = ref(null);

const handleClickOutside = (e) => {
  if (tooltip.value && !tooltip.value.contains(e.target)) {
    show.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});

</script>

<style scoped>
.tooltip {
  transition: opacity 0.2s;
}
</style>
